import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';

import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/classroom`;

export const ACTION_TYPES = {
  FETCH_CLASSROOM_LIST: 'classroom/FETCH_CLASSROOM_LIST',
  FETCH_CLASSROOM_LIST2: 'classroom/FETCH_CLASSROOM_LIST2',
  FETCH_CLASSROOM: 'classroom/FETCH_CLASSROOM',
  FETCH_CLASSROOM_LIST3: 'classroom/FETCH_CLASSROOM_LIST3',
  CREATE_CLASSROOM: 'classroom/CREATE_CLASSROOM',
  UPDATE_CLASSROOM: 'classroom/UPDATE_CLASSROOM',
  DELETE_CLASSROOM: 'classroom/DELETE_CLASSROOM',
  RESET: 'classroom/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entities2:[],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const classroomReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM_LIST2):
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM_LIST3):
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CLASSROOM):
    case REQUEST(ACTION_TYPES.UPDATE_CLASSROOM):
    case REQUEST(ACTION_TYPES.DELETE_CLASSROOM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM):
    case FAILURE(ACTION_TYPES.CREATE_CLASSROOM):
    case FAILURE(ACTION_TYPES.UPDATE_CLASSROOM):
    case FAILURE(ACTION_TYPES.DELETE_CLASSROOM):
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM_LIST2):
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM_LIST3):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM_LIST2):
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
        };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM_LIST3):
        return {
          ...state,
          loading: false,
          entities2: action.payload.data,
        };
    case SUCCESS(ACTION_TYPES.CREATE_CLASSROOM):
    case SUCCESS(ACTION_TYPES.UPDATE_CLASSROOM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CLASSROOM):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default classroomReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const getEntityBatch = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_LIST,
  payload: axios.get(`${apiUrl}/batch/${id}?sort=name,asc&size=50`),
});

export const getEntityCourse = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_LIST2,
  payload: axios.get(`${apiUrl}/course/${id}`),
});

export const getEntityManajemenAngkatan = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_LIST3,
  payload: axios.get(`${apiUrl}/course/${id}`),
});

export const createEntity = (entity, id, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CLASSROOM,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil Simpan!` },
  });
  dispatch(getEntityCourse(idcourse));
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CLASSROOM,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CLASSROOM,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil Hapus!` },
  });
  dispatch(getEntityCourse(idcourse));
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
